var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"node-edit__views"},[_c('vueActiveProduct'),_c('vueActiveProductDebts'),_c('vueHomeScreen'),_c('vueLatePayment'),_c('vueLocalBlock'),_c('vueVKYC'),_c('vuePaymentAmount'),_c('vueGraceDue'),_c('vueCloseGraceDue'),_c('vueEmiParametrs')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }